// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateInvite_createButton__1RB1w"};